<template>
    <div class="w-6 flex">
        <div class="w-full m-0 border border-gray-200 bg-white">
            <ui-dropdown menu-class="p-3 w-64" :ref="'dropdown'">
                <template #default="{ toggle }">
                    <div class="cursor-pointer relative w-[22px] h-[22px] mt-1.5"
                         @mouseover="estimate.readonly?false:mouseover()"
                         @mouseout="estimate.readonly?false:mouseout()"
                         @click="estimate.readonly?false:toggle()"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22px"
                            height="22px"
                            viewBox="0 0 36 36"
                            :fill="fill"
                            :stroke="stroke"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="absolute"
                            style="left: 0px; top: 0px"
                        >
                            <circle cx="18" cy="18" r="17"/>
                        </svg>
                        <div class="flex justify-center text-blue-500 relative mt-px" v-if="item.component">
                            <div class="mt-0.5 font-bold leading-4" style="font-size: 0.6em"
                                 v-text="item.component.substring(0,3)" :key="renderKey"></div>
                        </div>
                    </div>
                </template>
                <template #menu="{ close }">
                    <div :key="renderKey">
                        <ui-dropdown-item v-for="(comp,index) in (components)"
                                          :class="'focus:ring-0'"
                                          :key="index"
                                          :ticked="item.component === comp"
                                          @click="applyComponent(comp, close);"
                        >
                            <div class="cursor-pointer relative w-[22px] h-[22px] mt-0 mr-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22px"
                                    height="22px"
                                    viewBox="0 0 36 36"
                                    fill="#FFFFFF"
                                    :stroke="stroke"
                                    stroke-width="1"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="absolute"
                                    style="left: 0px; top: 0px"
                                >
                                    <circle cx="18" cy="18" r="17"/>
                                </svg>
                                <div class="flex justify-center text-blue-500 relative">
                                    <div class="mt-0.5 font-bold leading-4" style="font-size: 0.6em; padding-top:1px"
                                         v-text="comp.substring(0,3)"></div>
                                </div>
                            </div>
                            {{ comp }}
                        </ui-dropdown-item>
                    </div>
                    <div v-if="addNewComponent!==false" class="w-full flex">
                        <div class="pl-1.5 py-1.5">
                            <div class="cursor-pointer relative w-[22px] h-[22px] mt-0 mr-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22px"
                                    height="22px"
                                    viewBox="0 0 36 36"
                                    fill="#FFFFFF"
                                    :stroke="stroke"
                                    stroke-width="1"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="absolute"
                                    style="left: 0px; top: 0px"
                                >
                                    <circle cx="18" cy="18" r="17"/>
                                </svg>
                                <div class="flex justify-center text-blue-500 relative">
                                    <div class="mt-0.5 font-bold leading-4" style="font-size: 0.6em"
                                         v-text="newComponent.substring(0,3)"></div>
                                </div>
                            </div>
                        </div>
                        <input name="newTag" v-model="newComponent"
                               @keydown.enter="updateNewComp"
                               @blur.prevent.stop="updateNewComp"
                               ref="new-comp"
                               class="w-full block overflow-scroll border-none shadow-none ring-0 outline-none bg-transparent text-sm p-0 mt-0 mx-0 mb-0"
                        />
                    </div>
                    <ui-dropdown-divider v-if="components.length"></ui-dropdown-divider>
                    <ui-dropdown-item icon="fas fa-plus"
                                      @click.prevent.stop="addComponent">
                        Tag as a new Component
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiDropdownDivider from "../../../ui/UiDropdownDivider.vue";

export default {
    components: {UiDropdownDivider, UiDropdownItem},
    props: {
        estimate: Object,
        item: Object,
    },
    watch: {
        estimate: {
            handler(newValue, oldValue) {
                this.updateComponentsFromEstimate()
                this.renderKey++
            },
            deep: true
        },
    },
    computed: {},
    data() {
        return {
            fill: '#FFFFFF',
            stroke: 'rgb(59 130 246)',
            components: [],
            addNewComponent: false,
            newComponent: '',
            renderKey: 0,
        }
    },
    mounted() {
        this.updateComponentsFromEstimate(true)
    },
    methods: {
        mouseover() {
            this.fill = 'rgb(239 246 255)'
        },
        mouseout() {
            this.fill = '#FFFFFF'
        },
        applyComponent(component, close) {
            if (this.item.component === component) {
                this.item.component = undefined
            } else {
                this.item.component = component
                close();
            }
            this.newComponent = ''
            this.addNewComponent = false
            this.$emit('componentUpdated')
        },
        addComponent() {
            this.addNewComponent = true
            this.$nextTick(() => {
                this.$refs["new-comp"].focus()
            })
        },
        updateNewComp() {
            this.item.component = this.newComponent;
            this.newComponent = ''
            this.addNewComponent = false
            this.$emit('componentUpdated')
        },
        updateComponentsFromEstimate(useNewSet = false) {
            let comps = new Set();
            if (!useNewSet) {
                this.components.forEach(component => {
                    comps.add(component)
                });
            }
            const addItemComponent = (item) => {
                for (let m = 0; m < item.materials.length; m++) {
                    if (item.materials[m].component) {
                        comps.add(item.materials[m].component)
                    }
                }
                for (let m = 0; m < item.fixedCosts.length; m++) {
                    if (item.fixedCosts[m].component) {
                        comps.add(item.fixedCosts[m].component)
                    }
                }
                for (let m = 0; m < item.labour.length; m++) {
                    if (item.labour[m].component) {
                        comps.add(item.labour[m].component)
                    }
                }
            }
            for (let s = 0; s < this.estimate.scopeOfWorks.length; s++) {
                for (let t = 0; t < this.estimate.scopeOfWorks[s].tasks.length; t++) {
                    for (let i = 0; i < this.estimate.scopeOfWorks[s].tasks[t].items.length; i++) {
                        let item = this.estimate.scopeOfWorks[s].tasks[t].items[i];
                        if (item.bundle) {
                            for (let b = 0; b < this.estimate.scopeOfWorks[s].tasks[t].items[i].bundle.length; b++) {
                                addItemComponent(this.estimate.scopeOfWorks[s].tasks[t].items[i].bundle[b])
                            }
                        } else {
                            addItemComponent(this.estimate.scopeOfWorks[s].tasks[t].items[i])
                        }
                    }
                }
            }
            this.components = [...comps]
        },
    },
}
</script>